import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueI18nDirectives from 'vue-i18n-directives'

Vue.use(VueI18n)
Vue.use(VueI18nDirectives)
const messages = {
  
  en: {
    ...require('@/locales/en.json'),
  },
  es: {
    ...require('@/locales/es.json'),
  },
  pt: {
    ...require('@/locales/pt.json'),
  },
  fr: {
    ...require('@/locales/fr.json'),
  },
  cn: {
    ...require('@/locales/cn.json'),
  },
  ar: {
    ...require('@/locales/ar.json'),
  },
}
const lang = localStorage.getItem('locale') || 'en'

export default new VueI18n({
  locale: lang|| 'en',
  fallbackLocale: lang || 'en',
  messages,
})
